<template>
    <div class="table-responsive m-n3 rounded">
        <table class="table mb-0">
            <thead>
                <tr>
                    <th scope="col"></th>
                    <th scope="col" v-for="column in columns" class="text-center align-middle">
                        {{ $t(`parameters.${parameterId}.options.${column}`) }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(row, index) in rows">
                    <th scope="row" :class="{'border-0': index === rows.length - 1}">{{ $t(`parameters.${parameterId}.rows.${row}`) }}</th>
                    <td v-for="column in columns" :class="{'border-0': index === rows.length - 1}" class="text-center">
                        <label class="p-2 m-n3">
                        <input type="checkbox" @change="onChecked(row, column, $event.target.checked)" :checked="isChecked(row, column)">
                        </label>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script lang="ts">
import SvgIcon from '@/icons/SvgIcon.vue';
import {defineComponent, PropType, ref, watch} from 'vue';

type Value = Array<[string, string]>;

export default defineComponent({
    components: {SvgIcon},
    props: {
        parameterId: {
            type: String,
            required: true,
        },
        rows: {
            type: Array as PropType<string[]>,
            required: true,
        },
        columns: {
            type: Array as PropType<string[]>,
            required: true,
        },
        value: {
            type: Array as PropType<Value | null>,
            default: null,
        },
    },
    emits: ['input'],
    setup(props, {emit}) {
        const combinations = ref<Value>([]);

        // created logic
        if (props.value !== null) {
            combinations.value = [...props.value];
        }

        watch(combinations, () => {
            if (combinations.value.length === 0) {
                emit('input', null);
                return;
            }

            emit('input', combinations.value);
        });

        function isChecked(row: string, column: string): boolean {
            return combinations.value.some(
                ([checkedRow, checkedColumn]) => checkedRow === row && checkedColumn === column,
            );
        }

        function onChecked(row: string, column: string, checked: boolean): void {
            combinations.value = checked
                ? [[row, column], ...combinations.value]
                : combinations.value
                    .filter(([checkedRow, checkedColumn]) => checkedRow !== row || checkedColumn !== column)
                    .sort((a, b) => a.join().localeCompare(b.join()));
        }

        return {
            combinations,
            isChecked,
            onChecked,
        };
    },
});
</script>
